import { svg } from 'lit';

export default svg`
  <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M17.7724 4H20.6495L14.3654 11.201L21.7586 21H15.9704L11.4367 15.0559L6.24876 21H3.37048L10.0919 13.2972L3 4H8.93593L13.0335 9.43179L17.7724 4ZM16.7641 19.2742H18.3586L8.06834 5.63552H6.35897L16.7641 19.2742Z"></path>
  </svg>
`;
